<template>
    <div>
        <patient-list></patient-list>
    </div>
</template>
<script>
    import PatientList from './partials/PatientsList';
    
    export default {
        data () {
            return {

            }
        },
        components: {
            'patient-list': PatientList
        },
        mounted: function () {

        }
    }
</script>
<style lang="scss" scoped>

</style>